module.exports = __webpack_public_path__ + "img/step2-b.2c7306d6.png";